import { z } from 'zod';

export const Address = z
  .string()
  .refine((value) => !value.endsWith('.eth'), {
    message: 'ENS domain not yet supported, coming soon.',
    path: [],
  })
  .refine((value) => /^0x[a-fA-F0-9]{40}$/.test(value), {
    message: 'Invalid address',
    path: [],
  });

export const restrictedUsernames = [
  'admin',
  'root',
  'moderator',
  'system',
  'null',
  'undefined',
  'test',
  'user',
  'anonymous',
  'guest',
  'support',
  'helpdesk',
  'superuser',
  'owner',
  'bot',
  'ai',
  'dev',
  'debug',
  'error',
  '404',
  'noreply',
  'contact',
  'spam',
  'phishing',
  'hack',
  'script',
  'admin123',
  'superadmin',
  'system32',
  'localhost',
  'master',
  'slave',
  'reserved',
  'banned',
  'illegal',
  'offensive',
  'racist',
  'sexist',
  'explicit',
  'nsfw',
  'admin',
  'administrator',
  'sysadmin',
  'root',
  'superuser',
  'superadmin',
  'moderator',
  'mod',
  'manager',
  'boss',
  'chief',
  'lead',
  'adminstr',
  'console',
  'operator',
  'owner',
  'coadmin',
  'headadmin',
  'adminteam',
  'sysop',
  'security',
  'control',
  'masteradmin',
  'webmaster',
  'itadmin',
  'domainadmin',
  'serveradmin',
  'networkadmin',
  'mainadmin',
  'globaladmin',
  'siteadmin',
  'hostmaster',
  'adminpanel',
  'adm',
  'adm1n',
  'aDM1N',
  'systemadmin',
  'backend',
  'authadmin',
  'privileged',
  'elevated',
  'developer',
  'dev',
  'devops',
  'devops',
];
